/* ヘッダーのアイコン表示切替に用いる定数 */
export const PAGE_NAME_TOP = "top";
export const PAGE_NAME_SELECT_MODEL = "select_model";
export const PAGE_NAME_SELECT_PHENOMENON = "select_phenomenon";
export const PAGE_NAME_INFERENCE_FACTOR_ITEM = "inference_factor_item";
export const PAGE_NAME_FEEDBACK = "feedback";
export const PAGE_NAME_HOW_TO_FIX = "howtofix";
export const PAGE_NAME_ENGINE_LABEL_LOCATION = "engine_label_location";
export const PAGE_NAME_SEARCH_HISTORY = "search_history";
export const PAGE_NAME_FAVORITE = "favorite";
export const PAGE_NAME_DISCLAIMER = "notice";
export const PAGE_NAME_LOGIN = "";

/* 利用ログに用いるdisplayPage定数 */
export const DISPLAY_PAGE_TOP = "Troubleshooting";
export const DISPLAY_PAGE_CHOOSE_MODEL = "Engine Model Selection";
export const DISPLAY_PAGE_CHOOSE_MALFUNCTION = "Phenomenon Selection";
export const DISPLAY_PAGE_INFERENCE_FACTORS_ITEMS = "Inference Factors Items";
export const DISPLAY_PAGE_FEEDBACK = "Feedback";
export const DISPLAY_PAGE_HOW_TO_FIX = "How To Fix";
export const DISPLAY_PAGE_SEARCH_HISTORY = "Search History";
export const DISPLAY_PAGE_FAVORITE = "Favorite";
export const DISPLAY_PAGE_DISCLAIMER = "Notice";

//操作ガイドのリンク
export const PAGE_LINK_OPERATION_GUID =
  "https://vimeo.com/1054331178/6333bd00da?ts=0&share=copy";
export const PAGE_LINK_ERR_CORD_SEARCH =
  "https://ypt-ecs.yanmar.com/ecs/ypt_ecs/#/DTC-link/*/";
// 署名付きURLへのリンク
export const PRESIGNEDURL_LINK =
  "https://www.mof.go.jp/policy/budget/budger_workflow/account/fy2023/ke060731.pdf";

/* ヘッダーのアイコン表示切替に用いる定数 */
export const DISPLAY_HEADER_ICON_NONE = 0; //アイコンなし
export const DISPLAY_HEADER_ICON_BACK = 1; //戻るアイコン
export const DISPLAY_HEADER_ICON_CLOSE = 2; //閉じるアイコン

/* ダミーAPI制御用 */
//利用ログ登録
export const DUMMY_API_USAGELOG_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_USAGELOG_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_USAGELOG_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_USAGELOG_SYSTEM_ERR = 3; //異常系(システムエラー)

//未回答数取得
export const DUMMY_API_UNANSWERED_NORMAL_1 = 0; //正常系ケース1 未回答数0
export const DUMMY_API_UNANSWERED_NORMAL_2 = 1; //正常系ケース2 未回答数1
export const DUMMY_API_UNANSWERED_USER_ERR_1 = 2; //異常系(ユーザー要因)ケース1
export const DUMMY_API_UNANSWERED_SERVER_ERR_1 = 3; //異常系(サーバー要因)ケース1
export const DUMMY_API_UNANSWERED_SYSTEM_ERR = 4; //異常系(システムエラー)

//案件名確認
export const DUMMY_API_CHECK_SUBJECTNAME_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_CHECK_SUBJECTNAME_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1 バリデーションエラー
export const DUMMY_API_CHECK_SUBJECTNAME_USER_ERR_2 = 2; //異常系(ユーザー要因)ケース2 案件名重複エラー
export const DUMMY_API_CHECK_SUBJECTNAME_SERVER_ERR_1 = 3; //異常系(サーバー要因)ケース1
export const DUMMY_API_CHECK_SUBJECTNAME_SYSTEM_ERR = 4; //異常系(システムエラー)

//署名付きURL取得RESIGNEDURL
export const DUMMY_API_GET_PRESIGNEDURL_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_GET_PRESIGNEDURL_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_PRESIGNEDURL_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_PRESIGNEDURL_SYSTEM_ERR = 3; //異常系(システムエラー)

//フィードバック情報取得
export const DUMMY_API_GET_FBINFO_NORMAL_1 = 0; //正常系ケース1 未設定、解消要因なし、該当フラグなし
export const DUMMY_API_GET_FBINFO_NORMAL_2 = 1; //正常系ケース2 直った、解消要因なし、該当フラグあり
export const DUMMY_API_GET_FBINFO_NORMAL_3 = 2; //正常系ケース3 直った、解消要因1番目のみ、該当フラグなし
export const DUMMY_API_GET_FBINFO_NORMAL_4 = 3; //正常系ケース4 直った、解消要因1,3番目、該当フラグなし
export const DUMMY_API_GET_FBINFO_NORMAL_5 = 4; //正常系ケース5 直った、解消要因5つ全て、該当フラグなし
export const DUMMY_API_GET_FBINFO_NORMAL_6 = 5; //正常系ケース6 直らない、解消要因なし、該当フラグなし
export const DUMMY_API_GET_FBINFO_USER_ERR_1 = 10; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_FBINFO_SERVER_ERR_1 = 11; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_FBINFO_SYSTEM_ERR = 12; //異常系(システムエラー)

//フィードバック情報更新
export const DUMMY_API_UPDATE_FBINFO_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_UPDATE_FBINFO_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_UPDATE_FBINFO_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_UPDATE_FBINFO_SYSTEM_ERR = 3; //異常系(システムエラー)

//検索履歴情報登録
export const DUMMY_API_REGISTER_SEARCH_HISTORY_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_REGISTER_SEARCH_HISTORY_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_REGISTER_SEARCH_HISTORY_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_REGISTER_SEARCH_HISTORY_SYSTEM_ERR = 3; //異常系(システムエラー)

//検索履歴情報登録
export const DUMMY_API_INFERENCE_FACTOR_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_INFERENCE_FACTOR_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_INFERENCE_FACTOR_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_INFERENCE_FACTOR_SYSTEM_ERR = 3; //異常系(システムエラー)

//型式取得
export const DUMMY_API_GET_ENGINE_MODEL_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_GET_ENGINE_MODEL_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_ENGINE_MODEL_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_ENGINE_MODEL_SYSTEM_ERR = 3; //異常系(システムエラー)

//現象取得
export const DUMMY_API_GET_PHENOMENON_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_GET_PHENOMENON_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_PHENOMENON_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_PHENOMENON_SYSTEM_ERR = 3; //異常系(システムエラー)

//検索履歴情報一覧取得
export const DUMMY_API_GET_SEARCH_HISTORY_LIST_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_GET_SEARCH_HISTORY_LIST_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_SEARCH_HISTORY_LIST_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_SEARCH_HISTORY_LIST_SYSTEM_ERR = 3; //異常系(システムエラー)

//検索履歴情報詳細取得
export const DUMMY_API_GET_SEARCH_HISTORY_DETAIL_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_GET_SEARCH_HISTORY_DETAIL_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_SEARCH_HISTORY_DETAIL_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_SEARCH_HISTORY_DETAIL_SYSTEM_ERR = 3; //異常系(システムエラー)

//検索履歴情報削除
export const DUMMY_API_DELETE_SEARCH_HISTORY_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_DELETE_SEARCH_HISTORY_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_DELETE_SEARCH_HISTORY_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_DELETE_SEARCH_HISTORY_SYSTEM_ERR = 3; //異常系(システムエラー)

//お気に入り情報取得
export const DUMMY_API_GET_FAVORITE_INFO_NORMAL_1 = 0; //正常系ケース1 お気に入り情報なし
export const DUMMY_API_GET_FAVORITE_INFO_NORMAL_2 = 1; //正常系ケース2 お気に入り情報あり（"100","4TN107F＊-1＊","Adjustment of Intake and Exhaust Valves","20241125180000"）
export const DUMMY_API_GET_FAVORITE_INFO_USER_ERR_1 = 2; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_FAVORITE_INFO_SERVER_ERR_1 = 3; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_FAVORITE_INFO_SYSTEM_ERR = 4; //異常系(システムエラー)

//お気に入り情報一覧取得
export const DUMMY_API_GET_FAVORITE_INFO_LIST_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_GET_FAVORITE_INFO_LIST_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_FAVORITE_INFO_LIST_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_FAVORITE_INFO_LIST_SYSTEM_ERR = 3; //異常系(システムエラー)

//お気に入り閲覧日時更新
export const DUMMY_API_UPDATE_FAVORITE_DISPLAYDATETIME_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_UPDATE_FAVORITE_DISPLAYDATETIME_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_UPDATE_FAVORITE_DISPLAYDATETIME_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_UPDATE_FAVORITE_DISPLAYDATETIME_SYSTEM_ERR = 3; //異常系(システムエラー)

//お気に入りタイトル更新
export const DUMMY_API_UPDATE_FAVORITE_TITLE_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_UPDATE_FAVORITE_TITLE_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1 バリデーションエラー
export const DUMMY_API_UPDATE_FAVORITE_TITLE_USER_ERR_2 = 2; //異常系(ユーザー要因)ケース2 タイトル名重複エラー
export const DUMMY_API_UPDATE_FAVORITE_TITLE_SERVER_ERR_1 = 3; //異常系(サーバー要因)ケース1
export const DUMMY_API_UPDATE_FAVORITE_TITLE_SYSTEM_ERR = 4; //異常系(システムエラー)

//お気に入り情報登録
export const DUMMY_API_REGISTER_FAVORITE_INFO_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_REGISTER_FAVORITE_INFO_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_REGISTER_FAVORITE_INFO_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_REGISTER_FAVORITE_INFO_SYSTEM_ERR = 3; //異常系(システムエラー)

//お気に入り情報削除
export const DUMMY_API_DELETE_FAVORITE_INFO_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_DELETE_FAVORITE_INFO_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_DELETE_FAVORITE_INFO_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_DELETE_FAVORITE_INFO_SYSTEM_ERR = 3; //異常系(システムエラー)

//免責事項情報取得
export const DUMMY_API_GET_DISCLAIMER_INFO_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_GET_DISCLAIMER_INFO_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_DISCLAIMER_INFO_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_DISCLAIMER_INFO_SYSTEM_ERR = 3; //異常系(システムエラー)

//免責事項同意状態取得
export const DUMMY_API_GET_DISCLAIMER_AGREESTATUS_NORMAL_1 = 0; //正常系ケース1 未同意
export const DUMMY_API_GET_DISCLAIMER_AGREESTATUS_NORMAL_2 = 1; //正常系ケース2 同意済み
export const DUMMY_API_GET_DISCLAIMER_AGREESTATUS_USER_ERR_1 = 2; //異常系(ユーザー要因)ケース1
export const DUMMY_API_GET_DISCLAIMER_AGREESTATUS_SERVER_ERR_1 = 3; //異常系(サーバー要因)ケース1
export const DUMMY_API_GET_DISCLAIMER_AGREESTATUS_SYSTEM_ERR = 4; //異常系(システムエラー)

//免責事項同意状態更新
export const DUMMY_API_UPDATE_DISCLAIMER_AGREESTATUS_NORMAL_1 = 0; //正常系ケース1
export const DUMMY_API_UPDATE_DISCLAIMER_AGREESTATUS_USER_ERR_1 = 1; //異常系(ユーザー要因)ケース1
export const DUMMY_API_UPDATE_DISCLAIMER_AGREESTATUS_SERVER_ERR_1 = 2; //異常系(サーバー要因)ケース1
export const DUMMY_API_UPDATE_DISCLAIMER_AGREESTATUS_SYSTEM_ERR = 3; //異常系(システムエラー)

//フィードバック情報取得(3月追加分)
export const DUMMY_API_GET_FBINFO_NORMAL_7 = 6; //正常系ケース7 Fixed, 解消要因1番目のみ, 該当フラグなし

//言語の定数
export const LANGUAGE_ENGLISH = "en"; //英語(English)
export const LANGUAGE_JAPANESE = "ja"; //日本語(Japanese)

//時間の定数
export const SPLASH_DISPLAY_TIME = 3000; //3000ms(3秒)

//1ページあたりの表示件数(検索履歴画面, お気に入り画面)の定数
export const NUMBER_OF_ITEMS_DISPLAYED_PER_PAGE = 10; //10件
